import { LinearProgress, Stack } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";

import columns from "./cols";
import EmptyState from "./EmptyState";
import { ProductDetails } from "../../../models/Product";
import CustomPagination from "../../atoms/CustomPagination";

interface InventoryDataGridProps {
  rows?: ProductDetails[];
  loading?: boolean;
}

const InventoryDataGrid = ({ rows, loading }: InventoryDataGridProps) => {
  return (
    <Stack height={800} alignItems="center">
      <DataGrid
        loading={loading}
        data-testid="inventory-homepage-table"
        style={{ maxWidth: "100%", overflowX: "scroll" }}
        sx={{
          "& .MuiDataGrid-footerContainer": {
            justifyContent: "center",
          },
          "& .MuiDataGrid-cell:focus": {
            outline: "none",
          },
          "& .MuiDataGrid-row:hover": {
            backgroundColor: "primary.light",
          },
          "& .MuiDataGrid-row": {
            backgroundColor: "mono.white",
          },
        }}
        isRowSelectable={() => false}
        rows={rows || []}
        columns={columns}
        getRowId={(row: ProductDetails) => row.productId}
        initialState={{
          pagination: {
            paginationModel: { page: 0, pageSize: 12 },
          },
        }}
        slots={{
          pagination: CustomPagination,
          noRowsOverlay: EmptyState,
          loadingOverlay: LinearProgress,
        }}
      />
    </Stack>
  );
};

export default InventoryDataGrid;
